import {
    Button, Container, Dialog, Typography
} from '@material-ui/core'
import React from 'react'

import { buttonsStyles } from '../../styles/ButtonsStyles'

type Props = {
    disableAccept?: boolean
    onConfirmAction?:() => void
    onCancelAction?: () => void
    headerText: string
    isOpen: boolean
    onClose?: () => void
    confirmActionButtonText: string
    cancelActionButtonText: string
}

export const LogoutModal: React.FC<Props> = ({
    disableAccept,
    confirmActionButtonText,
    cancelActionButtonText,
    onConfirmAction,
    isOpen,
    headerText,
    onClose,
    onCancelAction
}) => {

    const btn = buttonsStyles()
    return (

        <Dialog
            style={{
                padding: 30,
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(0,0,30,0.4)'
            }}
            open={isOpen}
            onClose={onClose}
            keepMounted
            aria-describedby="alert-dialog-slide-description">
            <div style={{ padding: 30 }}>
                <Typography
                    style={{
                        color: 'white', textAlign: 'center', fontSize: 18, padding: 20
                    }}
                    variant="h6">{headerText}
                </Typography>
                <Container className={btn.buttonsWrapper}>
                    <Button
                        onClick={onConfirmAction}
                        variant="contained"
                        size="small"
                        disabled={disableAccept}
                        className={btn.saveButton}>
                        {confirmActionButtonText}
                    </Button>
                    <Button
                        onClick={onCancelAction}
                        variant="contained"
                        size="small"
                        className={btn.cancelButton}>
                        {cancelActionButtonText}
                    </Button>
                </Container>
            </div>
        </Dialog>

    )
}

LogoutModal.defaultProps = {
    disableAccept: false,
    onConfirmAction: undefined,
    onCancelAction: undefined,
    onClose: undefined,
}
